module.exports = __webpack_public_path__ + "static/media/neco.a9dac693.png";